import dayjs, {Dayjs} from "dayjs";

export default class DeathVote {
    public id: string
    public approved: boolean
    public comment: string
    public userName: string
    public round: number
    public createdAt: Dayjs

    constructor(data: any) {
        this.id = data.reference
        this.comment = data.comment
        this.round = data.round ?? 0
        this.userName = data.userName
        this.approved = data.approved
        this.createdAt = dayjs(data.createdAt)
    }
}
